module.exports = __webpack_public_path__ + "static/media/parlett_toward.9c4f9be4.jpg";